<template>
  <div class="d-flex">
    <v-card flat outlined class="ma-0 pa-0 mr-1" style="min-width: 48px">
      <v-card-title
        class="
          ma-0
          pa-0
          px-1
          caption
          font-weight-normal
          justify-center
          grey
          lighten-4
          grey--text
        "
        ><div class="headerClass">
          {{ $t("fabricTextStyleGroupControlsTitle") }}
        </div></v-card-title
      >
      <v-card-actions class="ma-0 pa-0 px-1">
        <v-spacer></v-spacer>

        <!-- GUMB SPREMENI STIL -->
        <v-card
          flat
          class="ma-0 pa-0 hover-item"
          @click="changeTextBrush()"
          :style="
            $vuetify.breakpoint.width > 400
              ? 'width: 48px; max-width: 48px'
              : 'width: 38px; max-width: 38px'
          "
        >
          <v-card-actions class="justify-center ma-0 pa-0">
            <v-icon color="accent" class="mt-1">mdi-auto-fix</v-icon>
          </v-card-actions>
          <v-card-title
            style="font-size: 10px"
            class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
            ><div class="headerClass">
              {{ $t("fabricTextMagicStyle") }}
            </div></v-card-title
          >
        </v-card>
        <v-spacer></v-spacer>
        <!-- GUMB SPREMENI PORAVNAVO BESEDILA -->
        <v-card
          flat
          class="ma-0 pa-0 hover-item"
          @click="formatAlignText()"
          :style="
            $vuetify.breakpoint.width > 400
              ? 'width: 48px; max-width: 48px'
              : 'width: 38px; max-width: 38px'
          "
        >
          <v-card-actions class="justify-center ma-0 pa-0">
            <v-icon color="accent" class="mt-1">mdi-format-align-center</v-icon>
          </v-card-actions>
          <v-card-title
            style="font-size: 10px"
            class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
            ><div class="headerClass">
              {{ $t("fabricTextStyleAlign") }}
            </div></v-card-title
          >
        </v-card>
        <v-spacer></v-spacer>
        <!-- GUMB SPREMENI BARVO OZADJA BESEDILA -->
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <v-card
              flat
              class="ma-0 pa-0 hover-item"
              v-on="on"
              :style="
                $vuetify.breakpoint.width > 400
                  ? 'width: 48px; max-width: 48px'
                  : 'width: 38px; max-width: 38px'
              "
            >
              <v-card-actions class="justify-center ma-0 pa-0">
                <v-icon
                  :color="textBrush.textColorBackground"
                  style="border: 1px solid silver"
                  >mdi-square</v-icon
                >
              </v-card-actions>
              <v-card-title
                style="font-size: 10px"
                class="
                  ma-0
                  pa-0
                  px-1
                  font-weight-normal
                  justify-center
                  grey--text
                "
                ><div class="headerClass">
                  {{ $t("fabricTextStyleBackgroundColor") }}
                </div></v-card-title
              >
            </v-card>
          </template>
          <v-card>
            <v-card-text class="pa-0">
              <v-color-picker
                flat
                :hide-mode-switch="true"
                show-swatches
                hide-canvas
                hide-inputs
                :dot-size="20"
                :swatches-max-height="$vuetify.breakpoint.height / 1.5"
                v-model="textBrush.textColorBackground"
                @input="formatColorFillBackground()"
              />
            </v-card-text>
          </v-card>
        </v-menu>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <v-card flat outlined class="ma-0 pa-0 mr-1" style="min-width: 48px">
      <v-card-title
        class="
          ma-0
          pa-0
          px-1
          caption
          font-weight-normal
          justify-center
          grey
          lighten-4
          grey--text
        "
        ><div class="headerClass">{{ $t("fabricTextFont") }}</div></v-card-title
      >
      <v-card-actions class="ma-0 pa-0 px-1">
        <v-spacer></v-spacer>

        <!-- GUMB SPREMENI FONT -->
        <v-card
          flat
          class="ma-0 pa-0 hover-item"
          @click="changeFontText()"
          :style="
            $vuetify.breakpoint.width > 400
              ? 'width: 48px; max-width: 48px'
              : 'width: 38px; max-width: 38px'
          "
        >
          <v-card-actions class="justify-center ma-0 pa-0">
            <v-icon color="accent" class="mt-1">mdi-format-font</v-icon>
          </v-card-actions>
          <v-card-title
            style="font-size: 10px"
            class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
            ><div class="headerClass">
              {{ $t("fabricTextFontName") }}
            </div></v-card-title
          >
        </v-card>
        <v-spacer></v-spacer>
        <!-- GUMB SPREMENI BARVO BESEDILA -->
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <v-card
              flat
              class="ma-0 pa-0 hover-item"
              v-on="on"
              :style="
                $vuetify.breakpoint.width > 400
                  ? 'width: 48px; max-width: 48px'
                  : 'width: 38px; max-width: 38px'
              "
            >
              <v-card-actions class="justify-center ma-0 pa-0">
                <v-icon
                  :color="textBrush.textColor"
                  style="border: 1px solid silver"
                  >mdi-square</v-icon
                >
              </v-card-actions>
              <v-card-title
                style="font-size: 10px"
                class="
                  ma-0
                  pa-0
                  px-1
                  font-weight-normal
                  justify-center
                  grey--text
                "
                ><div class="headerClass">
                  {{ $t("fabricTextFontColor") }}
                </div></v-card-title
              >
            </v-card>
          </template>
          <v-card>
            <v-card-text class="pa-0">
              <v-color-picker
                flat
                :hide-mode-switch="true"
                show-swatches
                hide-canvas
                hide-inputs
                :dot-size="20"
                v-model="textBrush.textColor"
                :swatches-max-height="$vuetify.breakpoint.height / 1.5"
                @input="formatColorFillText()"
              />
            </v-card-text>
          </v-card>
        </v-menu>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <v-card flat outlined class="ma-0 pa-0 mr-1" style="min-width: 48px">
      <v-card-title
        class="
          ma-0
          pa-0
          px-1
          caption
          font-weight-normal
          justify-center
          grey
          lighten-4
          grey--text
        "
        ><div class="headerClass">
          {{ $t("fabricTextOutlineGroupControlsTitle") }}
        </div></v-card-title
      >
      <v-card-actions class="ma-0 pa-0 px-1">
        <v-spacer></v-spacer>
        <!-- GUMB SPREMENI OBROBO BESEDILA -->
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <v-card
              flat
              class="ma-0 pa-0 hover-item"
              v-on="on"
              :style="
                $vuetify.breakpoint.width > 400
                  ? 'width: 48px; max-width: 48px'
                  : 'width: 38px; max-width: 38px'
              "
            >
              <v-card-actions class="justify-center ma-0 pa-0">
                <span style="text-color: 505050"
                  >{{ textBrush.shadowText }}
                </span>
              </v-card-actions>
              <v-card-title
                style="font-size: 10px"
                class="
                  ma-0
                  pa-0
                  px-1
                  font-weight-normal
                  justify-center
                  grey--text
                "
                ><div class="headerClass">
                  {{ $t("fabricTextOutlineWidth") }}
                </div></v-card-title
              >
            </v-card>
          </template>
          <v-card class="pa-4">
            <v-card-text class="pa-0">
              <v-slider
                v-model="textBrush.shadowText"
                class="align-center"
                :max="50"
                :min="0"
                hide-details
                vertical
                @change="formatShadowText()"
              ></v-slider>
            </v-card-text>
          </v-card>
        </v-menu>
        <v-spacer></v-spacer>
        <!-- GUMB SPREMENI BARVO OBROBE BESEDILA -->
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <v-card
              flat
              class="ma-0 pa-0 hover-item"
              v-on="on"
              :style="
                $vuetify.breakpoint.width > 400
                  ? 'width: 48px; max-width: 48px'
                  : 'width: 38px; max-width: 38px'
              "
            >
              <v-card-actions class="justify-center ma-0 pa-0">
                <v-icon
                  :color="textBrush.shadowTextColor"
                  style="border: 1px solid silver"
                  >mdi-square</v-icon
                >
              </v-card-actions>
              <v-card-title
                style="font-size: 10px"
                class="
                  ma-0
                  pa-0
                  px-1
                  font-weight-normal
                  justify-center
                  grey--text
                "
                ><div class="headerClass">
                  {{ $t("fabricTextOutlineColor") }}
                </div></v-card-title
              >
            </v-card>
          </template>
          <v-card>
            <v-card-text class="pa-0">
              <v-color-picker
                flat
                :hide-mode-switch="true"
                show-swatches
                hide-canvas
                hide-inputs
                :dot-size="20"
                :swatches-max-height="$vuetify.breakpoint.height / 1.5"
                v-model="textBrush.shadowTextColor"
                @input="formatShadowColor()"
              />
            </v-card-text>
          </v-card>
        </v-menu>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { parseRGBA } from "@/mixins/utils";

export default {
  name: "fabric-text-controls-card",
  props: {
    template: {
      type: Object,
      required: true,
    },
  },
  methods: {
    changeTextBrush() {
      this.template.canvas
        .getActiveObject()
        .set(
          "fontFamily",
          this.fonts[this.textBrushes[this.currentTextBrush].fontText]
        );

      this.template.canvas
        .getActiveObject()
        .set(
          "fill",
          parseRGBA(this.textBrushes[this.currentTextBrush].textColor)
        );

      this.template.canvas
        .getActiveObject()
        .set(
          "backgroundColor",
          parseRGBA(this.textBrushes[this.currentTextBrush].textColorBackground)
        );

      this.template.canvas
        .getActiveObject()
        .set("stroke", this.textBrushes[this.currentTextBrush].shadowTextColor);

      this.template.canvas
        .getActiveObject()
        .set("strokeWidth", this.textBrushes[this.currentTextBrush].shadowText);

      setTimeout(() => {
        this.template.canvas.getActiveObject().setCoords();
        this.template.canvas.requestRenderAll();

        this.currentTextBrush >= this.textBrushes.length - 1
          ? (this.currentTextBrush = 0)
          : this.currentTextBrush++;
        console.log(this.currentTextBrush);
      }, 500);
    },
    formatAlignText() {
      this.$store.commit({
        type: "showSnackbar",
        color: "accent",
        message: this.$t("fabricImageFilterBase") + ": center",
      });
      switch (this.currentAlignText) {
        case 0:
          this.template.canvas.getActiveObject().set("textAlign", "center");
          console.log("TEXT: CENTER");
          break;
        case 1:
          this.template.canvas.getActiveObject().set("textAlign", "left");
          console.log("TEXT: LEFT");
          break;
        case 2:
          this.template.canvas.getActiveObject().set("textAlign", "right");
          console.log("TEXT: RIGHT");
          break;
      }
      this.template.canvas.requestRenderAll();
      this.currentAlignText >= 2
        ? (this.currentAlignText = 0)
        : this.currentAlignText++;
      this.template.canvas.requestRenderAll();
    },
    formatColorFillBackground() {
      // pretvorimo HEX + alpha v rgba
      this.template.canvas
        .getActiveObject()
        .set("backgroundColor", parseRGBA(this.textBrush.textColorBackground));
      this.template.canvas.requestRenderAll();
    },
    changeFontText() {
      this.textBrush.fontText == 9
        ? (this.textBrush.fontText = 0)
        : this.textBrush.fontText++;

      this.template.canvas
        .getActiveObject()
        .set("fontFamily", this.fonts[this.textBrush.fontText]);

      setTimeout(() => {
        this.template.canvas.getActiveObject().setCoords();
        this.template.canvas.requestRenderAll();

        if (this.textBrush.fontText >= 9) this.textBrush.fontText = -1;
      }, 250);
    },
    formatColorFillText() {
      // pretvorimo HEX + alpha v rgba
      this.template.canvas
        .getActiveObject()
        .set("fill", parseRGBA(this.textBrush.textColor));
      this.template.canvas.requestRenderAll();
    },
    formatShadowText() {
      //console.log(this.textBrush.shadowText);
      this.template.canvas
        .getActiveObject()
        .set("strokeWidth", this.textBrush.shadowText);
      this.template.canvas.requestRenderAll();
    },
    formatShadowColor() {
      // pretvorimo HEX + alpha v rgba
      this.template.canvas
        .getActiveObject()
        .set("stroke", this.textBrush.shadowTextColor);
      this.template.canvas.requestRenderAll();
    },
  },
};
</script>

<style scoped>
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
}
.hover-item {
  cursor: pointer;
}
</style>